import { getApiUrl } from "./env";

const BASE_URL = `${getApiUrl()}/v1`;

export const logoutEndpoint = () => `${BASE_URL}/logout`;
export const loginEndpoint = () => `${BASE_URL}/login`;
export const getUtenteEndpoint = () => `${BASE_URL}/utente`;

export const getRichiesteEndpoint = () => `${BASE_URL}/richieste`;
export const getRichiestaEndpoint = (idRichiesta) =>
  `${BASE_URL}/richieste/${idRichiesta}`;

export const getVassoioItemEndpoint = (idRichiesta, idVassoioItem, idPortata) =>
  `${BASE_URL}/richieste/${idRichiesta}/vassoi/${idVassoioItem}/portate/${idPortata}`;
export const putVassoioItemEndpoint = (idRichiesta, idVassoioItem, idPortata) =>
  `${BASE_URL}/richieste/${idRichiesta}/vassoi/${idVassoioItem}/portate/${idPortata}`;
